// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"MobileNounBRWinEvent_iconWrapper__2zLS0","switchIcon":"MobileNounBRWinEvent_switchIcon__-l_-i","bold":"MobileNounBRWinEvent_bold__3DOQG"};